module.exports = __webpack_public_path__ + "img/banner-1.95ad6bf8.png";